import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import { generateCacheKey, withManualCache } from '@/utlility/cache-service';

const API_URL = process.env.NEXT_PUBLIC_API_URL;


// Fetch all galleries
export const fetchGalleries = createAsyncThunk(
  'galleries/fetchGalleries',
  async (organizationId, { rejectWithValue }) => {
    try {
      const url = `${API_URL}/api/galleries`;
      const payload = { organization_key: organizationId };
      const cacheKey = generateCacheKey(url, 'POST', payload);
      return await withManualCache(cacheKey, async () => {
        const response = await axios.post(url, payload);
        return response.data;
      });
    } catch (error) {
      const errorMessage = error.response?.data?.message || error.message || 'Unknown error';
      return rejectWithValue({ message: errorMessage });
    }
  }
);

// Fetch single gallery by ID
export const fetchGalleryDetails = createAsyncThunk(
  'galleries/fetchGalleryDetails',
  async (galleryId, { rejectWithValue }) => {
    try {
      const url = `${API_URL}/api/gallery/${galleryId}`;
      const cacheKey = generateCacheKey(url, 'GET');
      return await withManualCache(cacheKey, async () => {
        const response = await axios.get(url);
        return response.data;
      });
    } catch (error) {
      const errorMessage = error.response?.data?.message || error.message || 'Unknown error';
      return rejectWithValue({ message: errorMessage });
    }
  }
);

const galleriesSlice = createSlice({
  name: 'galleries',
  initialState: {
    galleries: [],
    galleryDetails: null,
    status: 'idle',
    detailsStatus: 'idle',
    error: null,
    detailsError: null,
  },
  reducers: {
    clearGalleryDetails: (state) => {
      state.galleryDetails = null;
    },
  },
  extraReducers: (builder) =>{
    builder
    .addCase(fetchGalleries.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(fetchGalleries.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.galleries = action.payload;
      })
      .addCase(fetchGalleries.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.payload;
      })

      // Handling single category fetching
      .addCase(fetchGalleryDetails.pending, (state) => {
        state.detailsStatus = 'loading';
      })
      .addCase(fetchGalleryDetails.fulfilled, (state, action) => {
        state.detailsStatus = 'succeeded';
        state.galleryDetails = action.payload;
      })
      .addCase(fetchGalleryDetails.rejected, (state, action) => {
        state.detailsStatus = 'failed';
        state.detailsError = action.payload;
      });
  }
});

export default galleriesSlice.reducer;


